export default __webpack_public_path__ + "static/media/placeholder.3c661e28.png";